import React from 'react';
import Menu from './Menu';
import './Menu.css';
import Logo from './Logo';

const Hue = () => {
  return (
    <div className="hue">
      <Menu />
      <div className="logo-container">
      <Logo />
      </div>
      <div className="search-container">
        <input type="text" placeholder="Search..." />
        <button className="search-button">Where?</button>
      </div>
    </div>
  );
};

export default Hue;
